import React from 'react';

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  label: string;
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

const Select: React.FC<SelectProps> = ({
  label,
  value,
  options,
  onChange,
  disabled = false,
  className = '',
}) => (
  <label className={`flex flex-col gap-1.5 text-sm ${className}`}>
    <span className="font-medium text-school-muted">{label}</span>
    <select
      value={value}
      disabled={disabled}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>): void => onChange(e.target.value)}
      className="min-h-[44px] rounded-xl border border-school-line bg-school-surface px-3 text-school-ink focus:border-school-primary focus:outline-none focus:ring-2 focus:ring-school-primary-soft disabled:opacity-50"
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </label>
);

export default Select;
